<template>
  <div>
    <AppNavigationTop :navigationInfo="AppNavigationTopInfo"/>
    <AccessList data="{tag='G1'}"/>
    <AppNavigationBottom/>
  </div>
</template>
<script>
import AppNavigationTop from "@/frame/navigation/components/AppNavigationTop";
import AccessList from "@/support/access/components/AccessList";
import currentPage from "@/frame/pages/mixins/currentPage.js";
import AppNavigationBottom from "@/frame/navigation/components/AppNavigationBottom";
import { mapGetters } from "vuex";

export default {
  components: {
    AppNavigationBottom,
    AppNavigationTop,
    AccessList
  },
  computed: {
    ...mapGetters(["getSearchResults", "getCurrentPage"]),
    pageTitle() {
      let title = null;
      if (this.getSearchResults !== null) {
        if (this.getSearchResults.length > 0) {
          let tagd = this.getSearchResults[0].basic.tagd;
          let tags = this.getSearchResults[0].basic.tags;
          if (tagd === "Z5" && tags === "C1") {
            title = "Admin Company Review";
          } else if (tagd === "U1" && tags === "C1") {
            title = "User Company Access";
          } else if (tagd === "C1" && tags === "U1") {
            title = "Company Users";
          } else if (tagd === "U1" && tags === "F1") {
            title = "User Facility Access";
          } else if (tagd === "F1" && tags === "U1") {
            title = "Facility Users";
          }
        } else {
          title = "Access No Data";
        }
      }
      return title;
    },
    AppNavigationTopInfo() {
      let nav = {
        title: "TBA",
        // eslint-disable-next-line
        btns: [
          {
            title: "company",
            icon: "apps",
            link: "/companydashbusiness"
          },
          {
            title: "sign out",
            icon: "person_outline",
            link: "/signout"
          }
        ]
      };
      nav.title = this.pageTitle;
      nav.btns[0].title = "Main";
      nav.btns[0].icon = "apps";
      nav.btns[0].link = "/appdash";
      nav.btns[1].title = "user";
      nav.btns[1].icon = "person";
      nav.btns[1].link = "/facilitydashmaintenance";
      if (this.getSearchResults !== null) {
        let tag = this.getSearchResults[0].basic.tag;
        let tagd = this.getSearchResults[0].basic.tagd;
        let tags = this.getSearchResults[0].basic.tags;

        if (tag === "G1" && tagd === "C1" && tags === "U1") {
          nav.btns[0].title = "Company";
          nav.btns[0].icon = "apps";
          nav.btns[0].link = "/companydash";
        }
      }
      return nav;
    }
  },
  mixins: [currentPage],
  data() {
    return {
      currentPagePath: "/accesslist"
    };
  },
  beforeMount() {
    this.$store.dispatch("changePreviousPage", this.getCurrentPage);
    this.$store.dispatch("changeCurrentPage", this.currentPagePath);
  }
};
</script>
